import type { UserState } from "@/redux/features/activeUserSlice"
import { Link, useStaticQuery, graphql } from "gatsby"
import Container from "@/components/Container"
import Logo from "@/components/Logo"
import Rows from "@/components/Rows"
import SocialLinks from "@/components/SocialLinks"
import * as styles from "@/styles/modules/Footer.module.scss"

export default function Footer({ activeUser }: { activeUser: UserState }) {
  const data: Queries.FooterQuery = useStaticQuery(graphql`
    query Footer {
      allSanityNavigation(filter: { navId: { eq: "footerNav" } }) {
        nodes {
          items {
            navItemUrl {
              linkType
              internalLink
              href
              blank
              title
            }
            _key
            text
            loggedInOnly
            loggedOutOnly
          }
        }
      }
    }
  `)

  const footerLinks = data.allSanityNavigation.nodes[0].items!

  return (
    <footer className={styles.wrapper}>
      <Container className={styles.container}>
        <Rows gap={5}>
          <Logo linkTo="/" />
          <nav className={styles.nav}>
            {footerLinks.map(link => {
              const { linkType, internalLink, href, blank, title } =
                link!.navItemUrl || {}
              const shouldDisplayLink =
                (link?.loggedInOnly && activeUser.ambassadorPermission) ||
                (!link?.loggedInOnly && !link?.loggedOutOnly) ||
                (link.loggedOutOnly && !activeUser.ambassadorPermission)
                  ? true
                  : false
              return (
                shouldDisplayLink &&
                (linkType === "internal" ? (
                  <Link
                    key={link!._key}
                    to={internalLink!}
                    className={styles.link}
                    title={title!}
                  >
                    {link!.text}
                  </Link>
                ) : (
                  // eslint-disable-next-line react/jsx-no-target-blank
                  <a
                    key={link!._key}
                    href={href!}
                    target={blank ? "_blank" : undefined}
                    rel={blank ? "noreferrer" : undefined}
                    className={styles.link}
                    title={title!}
                  >
                    {link!.text}
                  </a>
                ))
              )
            })}
          </nav>

          <SocialLinks className={styles.socialLinks} showEmailIcon={false} />

          <p className={`caption ${styles.footNote}`}>
            &copy;Copyright {new Date().getFullYear()} Donut News, Inc.
            &nbsp;|&nbsp; <Link to="/privacy">Privacy</Link>
          </p>
        </Rows>
      </Container>
    </footer>
  )
}
